import { useEffect } from 'react'
import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import { UPDATE_CLOUDINARY_CONFIG } from 'TypeDefs/AppContext'
import { useMutation } from '@apollo/client'
import { ReturnedCloudinaryConfig } from 'TypeDefs/NonprofitOrgConfig'
import CREATE_OR_RETRIEVE_CLOUDINARY_CONFIG from 'Apollo/Mutations/CreateOrRetrieveCloudinaryConfig'

const useCloudinaryConfig = () => {
  const dispatch = useAppDispatch()

  const {
    nonprofitOrgConfig: { orgId },
  } = useAppState()

  const [createOrRetrieveCloudinaryConfig] =
    useMutation<ReturnedCloudinaryConfig>(
      CREATE_OR_RETRIEVE_CLOUDINARY_CONFIG,
      {
        context: { clientName: 'batched' },
        onCompleted: (responseData) => {
          if (responseData?.createOrRetrieveCloudinaryConfig) {
            dispatch({
              type: UPDATE_CLOUDINARY_CONFIG,
              cloudinaryConfig: responseData.createOrRetrieveCloudinaryConfig,
            })
          }
        },
        onError: (err) => {
          // eslint-disable-next-line no-console
          console.error('GraphQL Mutation Error:', err)
        },
      }
    )

  window.addEventListener('beforeunload', () => {
    if (orgId)
      sessionStorage.setItem(`cloudinaryConfigFetched_${orgId}`, 'false')
  })

  useEffect(() => {
    if (!orgId) return

    const hasConfigBeenFetched = sessionStorage.getItem(
      `cloudinaryConfigFetched_${orgId}`
    )

    if (hasConfigBeenFetched === 'true') return

    createOrRetrieveCloudinaryConfig({
      variables: { orgId },
    })
      .then(() => {
        sessionStorage.setItem(`cloudinaryConfigFetched_${orgId}`, 'true')
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Mutation Failed when setting context:', err)
      })
  }, [orgId, createOrRetrieveCloudinaryConfig])
}

export default useCloudinaryConfig
